import { render, staticRenderFns } from "./CurriculumVitaeCertificate.vue?vue&type=template&id=4f3d4f51&"
import script from "./CurriculumVitaeCertificate.vue?vue&type=script&lang=js&"
export * from "./CurriculumVitaeCertificate.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumVitaeCertificate.vue?vue&type=style&index=0&id=4f3d4f51&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports